export default "__VITE_ASSET__CiKR5bOo__"